import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["preview", "imageContainer"]
    static values = {
        imageCount: Number,
        name: String,
        multiple: Boolean,
        text: String,
    }

    canvas;
    stream;
    video;
    cameraCanvas;
    imageCount = 0;

    connect() {
        this.append();
    }

    append() {
        this.element.innerHTML = '\n' +
            '            <div>\n' +
            '                <button data-action="click->camera#open" class="btn space-x-2">\n' +
            '                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>\n' +
            `                    <span>${this.textValue || "Take a picture" }</span>` +
            '                </button>\n' +
            '                <div data-camera-target="imageContainer" class="avatar">\n' +
            '                    <!-- Images will be inserted here -->\n' +
            '                </div>\n' +
            '            </div>\n'

        let div = document.createElement("div");

        div.innerHTML = '<div id="camera_container" class="hidden fixed z-50 w-screen h-screen bg-white top-0 left-0 bottom-0 right-0" >\n' +
            '      <div class="relative bg-black z-60 w-full h-full flex items-center justify-center">\n' +
            '        <div class="relative h-fit rounded-lg w-fit overflow-hidden">\n' +
            '          <video class="rounded-lg" id="camera_video" style="width: 400px; height: 400px" autoplay>\n' +
            '          </video>\n' +
            '          <button data-action="click->camera#close" class="rounded-full text-xs p-2 w-8 h-8 absolute top-14  flex items-center justify-center bg-red-400 z-1 text-white left-auto right-2">' +
            '            <i class="ph ph-x text-white"></i>\n' +
            '          </button>\n' +
            '          <button data-action="click->camera#capture" class="rounded-full p-2 w-12 h-12 absolute bottom-14  flex items-center justify-center bg-green-400 z-1 left-auto right-2">' +
            '            <i class="ph ph-camera"></i>\n' +
            '          </button>' +
            '        </div>' +
            '      </div>' +
            '      <canvas id="camera_canvas" style="display: none;"></canvas>' +
            '    </div>';

        this.element.append(div);
        this.canvas = this.element.querySelector('#camera_canvas');
        this.video = this.element.querySelector('#camera_video');
        this.cameraCanvas = this.element.querySelector('#camera_container');

    }

    handleEscKey = (event) => {
        if (event.key === 'Escape') {
            this.close(event);
        }
    }

    open(e) {
        e.preventDefault();
        this.startCamera();
    }

    show() {
        this.cameraCanvas.classList.remove('hidden');
    }

    hide() {
        this.cameraCanvas.classList.add('hidden');
    }

    close(event) {
        event && event.preventDefault();
        event && event.stopPropagation();
        this.stream.getTracks().forEach(function (track) {
            track.stop();
        });
        // Remove ESC key listener when camera closes
        document.removeEventListener('keydown', this.handleEscKey);


        this.hide();
    }


    async startCamera() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({video: true});
            console.log(this);
            this.video.srcObject = this.stream;
            document.addEventListener('keydown', this.handleEscKey);

            this.show();
        } catch (err) {
            alert("Error accessing the camera: " + err.message);
        }
    }

    capture(event) {
        event.preventDefault();
        const context = this.canvas.getContext('2d');
        this.canvas.width = this.video.videoWidth;
        this.canvas.height = this.video.videoHeight;
        context.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);

        // Convert canvas to blob
        this.canvas.toBlob((blob) => {
            const imageId = Date.now();
            const fileName = `capture_${imageId}.jpg`;

            // Create a File object from the blob
            const file = new File([blob], fileName, {type: 'image/jpeg'});

            // Create an object URL for preview
            const imageUrl = URL.createObjectURL(file);

            // Create a new image preview container
            const imageContainer = document.createElement('div');
            imageContainer.className = 'relative group w-fit';
            //                 <input type="file" name="job[images][]" class="hidden" />
            // Keep same design
            imageContainer.innerHTML = `
                <img src="${imageUrl}" class="image-gallery" />
                <input type="file" name="${this.nameValue}" class="hidden" />
                <button type="button" data-action="click->camera#removeImage"
                 data-image-id="${imageId}" 
                        class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 md:hidden md:group-hover:block">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>`;

            if (!this.multipleValue) {
                this.imageContainerTarget.innerHTML = "";
            }
            // Add the new image to the container
            this.imageContainerTarget.appendChild(imageContainer);

            // Set the file to the hidden input
            const fileInput = imageContainer.querySelector('input[type="file"]');
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            fileInput.files = dataTransfer.files;

            // Close the camera
            this.close();
        }, 'image/jpeg');
    }

    removeImage(event) {
        event.preventDefault();
        event.target.closest('.relative').remove();
    }

}
